document.addEventListener('click', (event) => {
  const btn = event.target.closest('.f-scrolling-promotion__toggle-hidden');
  if (!btn) return;
  
  event.stopImmediatePropagation();

  const parent = btn.closest('.f-scrolling-promotion__wrapper');
  const carousel = parent ? parent.querySelector('f-scrolling-promotion') : null;
  
  if (carousel) {
    const isPaused = btn.getAttribute('aria-pressed') === 'true';
    const textSpan = btn.querySelector('.pause-text');
    
    btn.setAttribute('aria-pressed', !isPaused);
    if (textSpan) {
      textSpan.textContent = isPaused ? 'Pause' : 'Play';
    }
    
    if (!isPaused) {
      carousel.classList.add('f-scrolling-promotion--paused');
    } else {
      carousel.classList.remove('f-scrolling-promotion--paused');
    }

    const allTracks = carousel.querySelectorAll('.f-promotion--animated');
    allTracks.forEach(track => {
      track.style.setProperty('animation-play-state', isPaused ? 'running' : 'paused', 'important');
      track.style.setProperty('animation-name', isPaused ? 'scrolling-left' : 'none', 'important');
    });
    
    console.log('Toggled', allTracks.length, 'tracks to:', isPaused ? 'Running' : 'Paused');
  }
}, true);